import { React } from "react";
import PropTypes from "prop-types";
import CourseLandingPageInstructorCard from "./CourseLandingPageInstructorCard";

function CourseLandingPageInstructor({ instructors, resource, title }) {
  const { url } = resource;
  const multipleInstructors = instructors.length > 1;

  const instructorHeading = multipleInstructors ? (
    <h2>Who <em><span className="lowercase">are<br/>the</span></em> Instructors?</h2>
  ) : (
    <h2>Who <em><span className="lowercase">is<br/>the</span></em> Instructor?</h2>
  )
  
  return (
    <div className="CourseLandingPage-instructor container">
      <div className="container-section container-content">
        {instructorHeading}
        <div className="instructor-list">
          {
            instructors.map((instructor, index) => {
              const reversed = multipleInstructors && index % 2 !== 0;
              return (
                <CourseLandingPageInstructorCard 
                  key={`course-landing-page-instructor-${index}`}
                  instructor={instructor}
                  reversed={reversed}
                  resourceURL={url}
                  title={title}
                />
              )
            })
          }
        </div>
      </div>
    </div>
    )
}

CourseLandingPageInstructor.propTypes = {
  resource: PropTypes.object,
  title: PropTypes.string,
};

export default CourseLandingPageInstructor;